import React, { Fragment } from "react";
import H3Text from "@Uilib/h3Text";
import Constants, { entityNameEnum } from "@Apis/constants";
import Helpers from "@Apis/helpers";
import { v4 as uuidv4 } from 'uuid';

export const INITIAL_STATE = {
  isUserReady: false,
  currentUpdate: '',
  isGetAttachment: false,
  linkPayment: false,
  showPayment: false,
  isCollapsed: false,
  cancellationRemarkPop: false,
  cancellationRemark: '',
  cancellationReasonIRP: '',
  showErrorIRN: false,
  showEWaybillFormDrawer: false,
  visible: false,
  dataForIssueStock: [],
  allStock: true,
  dataForViewInvoiceLines: [],
  isGstNumberEditable: false,
  updatedGstNumber: '',
  isUserReadyForPrefillData: false,
  isModalOpen: false,
  includeEWayBill: false,
  eWayBillType: 'pdf',
  isGenerateLabelModalOpen: false,
  isLabelAvailable: false,
  visibleColumns: {
    PRODUCT: {
      label: 'Product',
      visible: true,
      disabled: true,
    },
    QUANTITY: {
      label: 'Quantity',
      visible: true,
      disabled: true,
    },
    FULFILLED: {
      label: 'Fulfilled',
      visible: true,
      disabled: true,
    },
    PRICE: {
      label: 'Price',
      visible: true,
      disabled: true,
    },
    TAX: {
      label: 'TAX',
      visible: true,
      disabled: true,
    },
    DISCOUNT: {
      label: 'Discount',
      visible: true,
      disabled: true,
    },
    TOTAL: {
      label: 'Total',
      visible: true,
      disabled: true,
    },
  },
  downloadDocumentInBaseCurrency: false,
  downloadInvoiceWithTaxReport: false,
  selectedTags: [],
};

export const handleFileChangeHelper = ({ fileListData, props, updateState }) => {

  const { updateAttachment, selectedInvoice, getAttachmentById } = props;
  const fileList = fileListData?.fileList?.map((item) => ({
    ...item,
    url: item?.response?.response?.location || item?.url,
  }));

  const attachments = fileList?.map((attachment) => ({
    url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
  }));

  if (fileListData?.file.status === 'done') {
    const payload = {
      entity_id: selectedInvoice?.invoice_id,
      entity_name: 'invoice',
      attachments,
    };
    updateAttachment(payload, () => {
      getAttachmentById(selectedInvoice?.invoice_id, 'invoice', () => {
        updateState({
          isGetAttachment: true,
        });
      });
    });
  }
  if (fileListData?.file.status === 'removed') {
    const payload = {
      entity_id: selectedInvoice?.invoice_id,
      entity_name: 'invoice',
      attachments,
    };
    updateAttachment(payload, () => {
      getAttachmentById(selectedInvoice?.invoice_id, 'invoice', () => {
        updateState({
          isGetAttachment: true,
        });
      });
    });
  }

  updateState({
    fileList: attachments.length > 0 ? attachments : [],
  });
};

export const addAlpha = (color, opacity) => {
  // coerce values so ti is between 0 and 1.
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
};

export const getDataSource = (data) => {
  const newData = JSON.parse(JSON.stringify(data));
  return newData;
};

export const renderFreightHelper = ({ position, props }) => {

  const { selectedInvoice, MONEY, } = props;
  if ((selectedInvoice?.charge_1_value > 0)) {
    if (position === 'top' && selectedInvoice?.freight_tax_id) {
      return (
        <div className="view-document__totals-field">
          <H3Text
            text={(
              <Fragment>
                {selectedInvoice?.charge_1_name}
                &nbsp;
                <span className="table-subscript">{`tax@${selectedInvoice?.freight_tax_info?.tax_value}%`}</span>
              </Fragment>
            )}
            className="view-document__totals-field-name"
          />
          <H3Text text={MONEY((selectedInvoice?.charge_1_value), selectedInvoice?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
        </div>
      );
    }
    if (position === 'bottom' && !selectedInvoice?.freight_tax_id) {
      return (
        <div className="view-document__totals-field">
          <H3Text text={selectedInvoice?.charge_1_name} className="view-document__totals-field-name" />
          <H3Text text={MONEY((selectedInvoice?.charge_1_value), selectedInvoice?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
        </div>
      );
    }
  }
  return '';
};

export const splitChargesData = (charge) => {
  const chargeWithTaxName = charge?.filter((line) => line?.tax_info?.tax_id) || [];
  const chargeWithoutTaxName = charge?.filter((line) => !line?.tax_info?.tax_id) || [];
  return { chargeWithTaxName, chargeWithoutTaxName };
};

export const getTotalQuantity = (invoiceLines) => invoiceLines?.reduce((acc, line) => acc + line?.quantity, 0);

export const renderChargesHelper = ({ charge, props }) => !!charge?.length && charge?.map((otherCharge, i) => {

  const { MONEY, selectedInvoice, } = props;
  return (
    <div key={i} className="view-document__totals-field">
      <H3Text
        text={(
          <Fragment>
            {otherCharge?.charge_name?.toProperCase()}
            &nbsp;
            {otherCharge?.tax_info?.tax_value ? (
              <span className="table-subscript">{`tax@${otherCharge.tax_info.tax_value}%`}</span>
            ) : null}
          </Fragment>
        )}
        className="view-document__totals-field-name"
      />
      {otherCharge?.charge_amount < 0
        ? <H3Text text={`(-)${MONEY((Math.abs(otherCharge?.charge_amount)), selectedInvoice?.org_currency_info?.currency_code)}`} className="view-document__totals-field-value danger-text" />
        : <H3Text text={MONEY((Math.abs(otherCharge?.charge_amount)), selectedInvoice?.org_currency_info?.currency_code)} className="view-document__totals-field-value " />}
    </div>
  );
});

export const HideAdhocApprovalsHelper = ({ props }) => {

  const { selectedInvoice } = props;

  if (selectedInvoice?.workflow_steps) {
    const steps = Object.values(selectedInvoice?.workflow_steps)?.filter((step) => step !== null);
    const pendingSteps = steps?.filter((step) => step?.status === 'PENDING');
    return steps.length < 10 && pendingSteps.length === steps.length;
  }
  return false;
};

export const getLinkedDocumentInfoHelper = ({ props, state, updateState }) => {

  const {
    selectedInvoice, user, priceMasking,
  } = props;

  const { showViewPayout, openDCModalView } = state;

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  let linkedDocumentsInfo = [];

  if (selectedInvoice?.credit_notes?.length > 0) {

    let documentDataInfo = [];

    selectedInvoice?.credit_notes?.forEach((item) => {
      documentDataInfo.push({
        documentId: item?.cn_id,
        documentNumber: item?.credit_note_number,
        documentStatus: item?.status,
        documentTotal: item?.document_cn_grand_total || item?.cn_grand_total,
      });
    });

    const cnDataInfo = {
      entityName: entityNameEnum.INVOICE,
      entityVisible: Helpers.getPermission(Helpers.permissionEntities.CREDIT_NOTE, Helpers.permissionTypes.READ, user) && selectedInvoice?.status === 'CONFIRMED',
      title: 'ASSOCIATED CREDIT NOTES',
      entityNumberPrefix: '',
      documentData: documentDataInfo,
      isRedirect: true,
      redirectPath: '/sales/credit-note/view/',
      hidePrice: isDataMaskingPolicyEnable && isHideCostPrice,
      popOverMessage: "You don't have access to view amount",
      showEntityTotal: true,
    }

    linkedDocumentsInfo.push(cnDataInfo);
  }

  if (selectedInvoice?.invoice_payments?.length > 0) {

    let documentDataInfo = [];

    selectedInvoice?.invoice_payments?.forEach((item) => {
      documentDataInfo.push({
        documentId: item?.payment_id,
        documentNumber: item?.applied_payment_type === 'PAYMENT' ? item?.payment_id : item?.credit_note_number,
        documentStatus: item?.status,
        documentTotal: item?.amount,
      });
    });

    const paymentDataInfo = {
      entityName: entityNameEnum.INCOMING_PAYMENTS,
      entityVisible: !(isDataMaskingPolicyEnable && (isHideCostPrice || isHideSellingPrice)),
      title: "LINKED PAYMENTS",
      entityNumberPrefix: '',
      documentData: documentDataInfo,
      isDrawer: true,
      drawerState: showViewPayout,
      drawerCallback: (payment, isOpen) => updateState({ selectedPayment: payment, showViewPayout: isOpen }),
      showEntityTotal: true,
    };

    linkedDocumentsInfo.push(paymentDataInfo);
  }

  if (selectedInvoice?.reference_dc?.length > 0) {

    let documentDataInfo = [];

    selectedInvoice?.reference_dc?.forEach((item) => {
      documentDataInfo.push({
        documentId: item?.delivery_challan_id,
        documentNumber: item?.dc_number,
        documentStatus: item?.status,
      });
    });

    const dcDataInfo = {
      entityName: entityNameEnum.DELIVERY_CHALLAN,
      entityVisible: Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.READ, user),
      title: "DELIVERY CHALLANS",
      entityNumberPrefix: 'DC',
      documentData: documentDataInfo,
      isDrawer: true,
      drawerState: openDCModalView,
      drawerCallback: (dc, isOpen) => updateState({ selectedDC: dc, openDCModalView: isOpen }),
      showEntityTotal: false,
    };

    linkedDocumentsInfo.push(dcDataInfo);
  }

  return linkedDocumentsInfo;
};

export function handleInvoiceDownload({
  isExcel = false,
  withTaxReport = false,
  inBaseCurrency = false,
  includeEWayBill = false,
  eWayBillType = 'pdf',
  updateState,
  user,
  selectedInvoice,
  downloadDocument,
}) {
  updateState({ includeEWayBill: includeEWayBill });

  const allowMultipleCopies =
    user?.tenant_info?.sales_config?.sub_modules?.invoice?.settings
      ?.allow_invoice_to_print_multiple_copies;

  if (allowMultipleCopies && !isExcel) {
    updateState({
      isModalOpen: true,
      downloadDocumentInBaseCurrency: inBaseCurrency,
      downloadInvoiceWithTaxReport: withTaxReport,
      includeEWayBill,
      eWayBillType,
    });
    return;
  }

  const downloadTypePath = isExcel ? '/excel' : '';
  const url = `${Constants.Invoice}/download${downloadTypePath}?invoice_id=${selectedInvoice?.invoice_id}&tenant_id=${selectedInvoice?.tenant_id}&include_eWay_bill=${includeEWayBill}&ewb_type=${eWayBillType}&download_document_in_base_currency=${inBaseCurrency}&required_tax_analysis_report=${withTaxReport}`;

  downloadDocument({
    url,
    document_type: 'INVOICE',
    document_number: selectedInvoice?.invoice_number,
    key: uuidv4(),
  });
}